import React from 'react';
import { array, arrayOf, func, node, number, object, oneOfType, string } from 'prop-types';
import { MenuItem } from 'material-ui';
import { includes } from 'ramda';
import { injectIntl } from 'react-intl';

import TextFieldBox from 'components/TextFieldBox';
import MaterialSelectField from 'components/MaterialSelectField';
import { colors } from 'styles/provider';

import { row, bullet } from './TextInput.less';

const TextInputWithSuggestions = ({
  color = 'red',
  value,
  onChange,
  name,
  textPlaceholder,
  suggestions,
  suggestionsLocale,
  intl,
}) => {
  const { formatMessage, messages } = intl;
  const fm = id => formatMessage({ id });

  // Get actual localizations for suggestion fields
  const suggestionsMessages =
    suggestions && suggestions.map(s => (suggestionsLocale ? messages[suggestionsLocale + s] : s));

  const bulletBG = color === 'green' ? colors.clrSuccessDefault : colors.clrErrorDefault;

  const selectionValue = includes(value, suggestionsMessages) ? value : '';
  const selectionOnChange = (event, index, value) => {
    onChange({ currentTarget: { value } });
  };
  return (
    <div className={row}>
      <div className={bullet} style={{ backgroundColor: bulletBG }} />

      <TextFieldBox
        editing
        input={{
          onChange: onChange,
          value: value,
          name: name,
        }}
        viewStyle={{ marginTop: 0, marginRight: '2rem', flex: 5 }}
        placeholder={textPlaceholder}
      />

      <div>
        <MaterialSelectField
          onChange={selectionOnChange}
          value={selectionValue}
          hintText={fm('onlineRehabilitation.suggestions.placeholder')}
          style={{ width: '20rem' }}
          autoWidth
        >
          {suggestionsMessages && suggestionsMessages.map(s => <MenuItem key={s} value={s} primaryText={s} />)}
        </MaterialSelectField>
      </div>
    </div>
  );
};

TextInputWithSuggestions.propTypes = {
  color: string,
  value: oneOfType([array, string, number]),
  onChange: func,
  name: string,
  textPlaceholder: node,
  suggestions: arrayOf(string),
  suggestionsLocale: string,
  intl: object,
};

export default injectIntl(TextInputWithSuggestions);
